<template>
	<v-container grid-list-xl>
      <v-layout row wrap>
        <v-tabs slider-color="grey">
          <v-tab class="tab" :key="1" ripple>Details</v-tab>
          <v-tab class="tab" :key="2" ripple>Vendor Ranges</v-tab>
          <v-tab class="tab" :key="3" ripple>Vendor Product Codes</v-tab>
          <v-tab class="tab" :key="4" ripple>Vendor Department / Store</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-form v-model="isAddValid">
                <v-layout row wrap>
                  <v-flex lg4>
                    <label class="blackLabel">* Vendor Name:</label>
                    <v-text-field label="Name" v-model="vendorName" required :rules="nameRules" single-line solo></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Vendor Email:</label>
                    <v-text-field label="Email" v-model="vendorEmail" required :rules="emailRules" single-line solo></v-text-field>
                  </v-flex>
                  <v-flex lg4>
                    <label class="blackLabel">* Vendor ID ( Hybris / ERP ):</label>
                    <v-text-field label="Vendor ID" v-model="vendorDescription" required :rules="descriptionRules" single-line solo></v-text-field>
                  </v-flex>
                  <v-flex lg12>
                    <label class="blackLabel">* Vendor Address:</label>
                    <v-text-field multi-line v-model="vendorAddress" solo label="Address"></v-text-field>
                  </v-flex>
                </v-layout>
                </v-form>
          </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <label class="blackLabel">Vendor Manufacturer:</label>
                  <v-select @input="fncGetRanges" :items="vendorManufacturers" label="Manufacturer" class="dropdown" v-model="vendorManufacturer" autocomplete item-text="name" solo single-line></v-select>
                </v-flex>
                <v-flex class="whiteShort" lg6 v-if="vendorManufacturerRanges != ''">
                  <label class="blackLabel">Vendor Ranges:</label>
                  <v-select :items="vendorManufacturerRanges" @input="fncListRanges" label="Manufacturer Range" class="dropdown" v-model="vendorManufacturerRange" multiple autocomplete item-text="name" solo single-line></v-select>
                </v-flex>
                <table width="100%" style="margin-left: 1%;">
                  <tr v-for="(group,group_name,index) in objList" :key="index">
                    <td valign="top">
                      <div v-for="(x,y,z) in group"><small>{{ group_name }} - {{ x.name }}</small><a @click.prevent="fncRemoveRange(x.id32)"><i style="font-size:16px;" class="material-icons">remove_circle_outline</i></a><br /></div>
                    </td>
                  </tr>
                </table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <input type="file" id="articleImport" @change="fncSetImageObj">
                </v-flex>
                <v-flex lg3 v-for="(product_code, index) in product_codes">
                  <v-text-field label="Product Code" v-model="product_codes[index].value" single-line solo></v-text-field>
                  <a @click="fncRemoveVendorRange(index)" class="departmentRangeRemove">Remove</a>
                </v-flex>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Save Product Code</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex xs3 v-if="objAuthorize.department_active == 1" style="padding-left: 0px !important; margin-left: 0px !important;">
                  <v-text-field append-icon="search" label="Filter Branches" style="margin-left: 0px !important;" solo single-line v-model="search"></v-text-field>
                </v-flex>
                <v-data-table :headers="branchHeaders" :search="search" ref="sortableTable" :items="branchesDepartments" hide-actions class="elevation-1 settingTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                  <template slot="headers" slot-scope="row">
                    <tr>
                      <th v-for="header in branchHeaders" :key="header.value" :width="header.width" >
                        <span v-if="header.value === 'select_all'"><v-switch  @change="selectAllItems" label="Select All" :indeterminate="isIndeterminate" v-model="selectAll"> Select All</v-switch></span>
                        <span v-else> {{ header.text }} </span>
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="15%"></td>
                      <td width="15%"><v-switch @change="fncChangeObject()" v-model="props.item.active"></v-switch></td>
                      <td width="40%">{{ props.item.name }}</td>
                      <td width="40%"><v-select style="width:90%;border: none !important;" :items="departmentList" label="Select Departments" v-model="props.item.departments" item-text="name" item-value="id" autocomplete multiple solo></v-select></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="update_vars" @click.stop="fncAddVendor()">Save</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
		<!--<v-form v-model="isAddValid">
			<v-layout row wrap>
				<v-flex lg4>
					<label class="blackLabel">* Vendor Name:</label>
					<v-text-field label="Name" v-model="vendorName" required :rules="nameRules" single-line solo></v-text-field>
				</v-flex>
              <v-flex lg4>
                <label class="blackLabel">* Vendor Email:</label>
                <v-text-field label="Email" v-model="vendorEmail" required :rules="emailRules" single-line solo></v-text-field>
              </v-flex>
				<v-flex lg4>
					<label class="blackLabel">* Vendor Description:</label>
					<v-text-field label="Description" v-model="vendorDescription" required :rules="descriptionRules" single-line solo></v-text-field>
				</v-flex>
              <v-flex lg6>
                <label class="blackLabel">* Vendor Manufacturer:</label>
                <v-select @input="fncGetRanges" :items="vendorManufacturers" label="Manufacturer" class="dropdown" v-model="vendorManufacturer" autocomplete :rules="manufacturerRules" item-text="name" solo single-line></v-select>
              </v-flex>
              <v-flex class="whiteShort" lg6 v-if="vendorManufacturerRanges != ''">
                <label class="blackLabel">* Vendor Ranges:</label>
                <v-select :items="vendorManufacturerRanges" @input="fncListRanges" label="Manufacturer Range" class="dropdown" v-model="vendorManufacturerRange" multiple autocomplete :rules="rangeRules" item-text="name" solo single-line></v-select>
              </v-flex>
              <table width="100%" style="margin-left: 1%;">
                <tr v-for="(group,group_name,index) in objList" :key="index">
                  <td valign="top">
                    <div v-for="(x,y,z) in group"><small>{{ group_name }} - {{ x.name }}</small><a @click.prevent="fncRemoveRange(x.id32)"><i style="font-size:16px;" class="material-icons">remove_circle_outline</i></a><br /></div>
                  </td>
                </tr>
              </table>

				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddVendor()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>
			</v-layout>
		</v-form>-->
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
        return {
          selectAll: false,
          isIndeterminate: false,
          branchesDepartments: [],
          articleImport: '',
          branchHeaders: [
            {text: 'Select all', value: 'select_all', width: '15%'},
            { text: 'Select', value: '', width: '15%' },
            { text: 'Branch', value: 'name', width: '40%' },
            { text: 'Department', value: '', width: '40%' }
          ],
                vendorManufacturerRange: [],
				isAddValid: false,
				vendorName: '',
                vendorAddress: '',
                vendorDescription: '',
                vendorManufacturer: '',
                vendorEmail: '',
                objList: [],
				nameRules: [
					v => !!v || 'Vendor name is required',
				],
				descriptionRules: [
					v => !!v || 'Vendor description is required',
                ],
                manufacturerRules: [
                  v => !!v || 'Vendor manufacturer is required',
                ],
                rangeRules: [
                  v => !!v || 'Manufacturer range is required',
                ],
                emailRules: [
                  v => !!v || 'Vendor email is required',
                ],
                manufacturers: [
                  { id: '1', text: 'Manufacturer One' },
                  { id: '2', text: 'Manufacturer Two' }
                ],
                rangeList: '',
                pdfOptions: [
                  /*{ key: 'one', label: 'One', status: false, altLabel: '' },
                  { key: 'two', label: 'Two', status: false, altLabel: '' },
                  { key: 'three', label: 'Three', status: false, altLabel: '' },*/
                ],
                pdfHeaders: [
                  { text: 'Display', value: 'status', width: '10%' },
                  { text: 'Description', value: 'label', width: '45%' },
                  { text: 'Alternate Description', value: 'altLabel', width: '45%' }
                ],
          product_codes: [{ value: '' }],
          search: ''
			};
		},
      methods: {
        fncRemoveVendorRange( index ) {
          var newProductCodes = [];
          for( var i in this.product_codes ) {
            if( i != index ) {
              newProductCodes.push(this.product_codes[i]);
            }
          }
          if( newProductCodes.length == 0 ) {
            newProductCodes = [{ value: '' }];
          }
          this.product_codes = newProductCodes;
        },
        fncSetImageObj(e) {
          var files = e.target.files || e.dataTransfer.files;
          var reader = new FileReader();
          var vm = this;
          reader.onload = function(e) {
            var articleNumbers = reader.result;
            var articleRows = articleNumbers.split("\r\n");
            console.log( articleRows );
            if( articleRows.length > 0 ) {
              // vm.product_codes = [];
              for( var a in articleRows ) {
                if( articleRows[a] != '' ) {
                  vm.product_codes.push({value: articleRows[a]});
                }
              }
            }
            /*vm.objRows = articleNumbers.split("\r\n");
            vm.fileName = files[0].name;*/
          }
          reader.readAsText(files[0]);
        },
        selectAllItems() {
          const selectedValue = this.selectAll;
          if (this.selectAll) {
            const firstItemDepartments = this.branchesDepartments[0].departments;
            this.branchesDepartments.forEach((item) => {
              item.departments = firstItemDepartments;
              item.active = selectedValue;
            });
          } else {
            // Clear all departments when "Select All" is unchecked
            this.branchesDepartments.forEach((item) => {
              item.departments = [];
              item.active = selectedValue;
            });
          }
        },
        fncChangeObject() {
          var toPush = [];

          for( var b in this.branchesDepartments ) {
            if( this.branchesDepartments[b].active == true ) {
              toPush.push( this.branchesDepartments[b] );
            }
          }
          for( var b in this.branchesDepartments ) {
            if( this.branchesDepartments[b].active == false ) {
              toPush.push( this.branchesDepartments[b] );
            }
          }

          this.branchesDepartments = toPush;

        },
        fncAddProductCode() {
          this.product_codes.push({ value: '' });
        },
        fncListRanges() {
          var res = {};
          for (let d = 0; d < this.vendorManufacturerRange.length; d++) {
            let doc = this.vendorManufacturerRange[d];
            if (res[doc.headName] === undefined) {
              res[doc.headName] = []
            }
            res[doc.headName].push(doc);
          }

          this.objList = res;

        },
        fncRemoveRange(id) {

          var toReturn = [];

          for (var x in this.vendorManufacturerRange) {
            if ( this.vendorManufacturerRange[x].id32 != id ) {
              toReturn.push(this.vendorManufacturerRange[x] );
            }
          }

          this.vendorManufacturerRange = toReturn;
          this.fncListRanges();

        },
        fncGetRanges() {
              this.$store.dispatch('fncGetManufacturerRanges', this.vendorManufacturer )
            },
			fncHideModal () {
				this.$store.commit('hideModal');
        setTimeout(function(){
          location.reload();
        }, 1000)
			},
			fncAddVendor() {
				this.$store.dispatch({
					type: 'fncAddVendor',
					vendorDetails: {
						vendorName: this.vendorName,
                        vendorDescription: this.vendorDescription,
                        vendorAddress: this.vendorAddress,
                        vendorManufacturer: this.vendorManufacturer.id,
                        vendorEmail: this.vendorEmail,
                        vendorRanges: this.vendorManufacturerRange,
                        vendorPdf: this.pdfOptions,
                        vendorProductCodes: this.product_codes,
                        branchesDepartments: this.branchesDepartments
					}
                });
                this.vendorName = '';
                this.vendorDescription = '';
                this.vendorAddress = '';
                this.vendorManufacturer = '';
                this.vendorManufacturerRange = [];
                this.vendorEmail = '';
                this.product_codes = [{ value: '' }];
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
         'runAdd',
         'vendorManufacturers',
         'vendorManufacturerRanges',
         'departmentList',
         'branchList'
			]),
      update_vars(){
        if (this.isAddValid && this.product_codes.every(item => item.value !== '') )
          return  false
        else
          return  true
      }
		},
    beforeMount() {

      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateBranches');

    },
    mounted() {
      var toPush = [];
      for( var b in this.branchList ) {
        if( this.branchList[b].id != '' ) {
          var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [] };
          toPush.push( miniPush );
        }
      }
      this.branchesDepartments = toPush;
    },
    watch: {
	    branchList() {
        var toPush = [];
        for( var b in this.branchList ) {
          if( this.branchList[b].id != '' ) {
            var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [] };
            toPush.push( miniPush );
          }
        }
        this.branchesDepartments = toPush;
      },
            runAdd() {
                if( this.runAdd === false ) {
                    this.isAddValid = false;
                    this.roleActive = '';
                    this.roleName = '';
                    this.roleDescription = '';
                    this.roleLevel = '';
                    this.roleUserType = '';
                }
            }
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
